import React, { useState, useEffect } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import { useNavigate } from 'react-router-dom'
import { axiosInstance } from '../Config'
import config from '../Config'
import swal from 'sweetalert'
import Loader from '../Loader'

const avatarColors = ['#A44CD7', '#0CACC2', '#F55145', '#F9BE22', '#8A3BBD', '#19C37D', '#5A79DF', '#EC2434']
const getInitials = (name = '') => name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)

const CreatorIndex = () => {
    const navigate = useNavigate()

    const [allCreators, setAllCreators] = useState([])
    const [filtered, setFiltered] = useState([])
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')

    useEffect(() => {
        document.title = 'Creators | Mindora'
        window.scrollTo(0, 0)
        fetchCreators()
    }, [])

    useEffect(() => {
        const q = search.trim().toLowerCase()
        setFiltered(q
            ? allCreators.filter(c =>
                c.name?.toLowerCase().includes(q) ||
                c.email?.toLowerCase().includes(q) ||
                c.phone?.includes(q)
            )
            : allCreators
        )
    }, [search, allCreators])

    const fetchCreators = async () => {
        setLoading(true)
        try {
            const res = await axiosInstance.get('creators')
            const data = res.data?.data ?? res.data ?? []
            setAllCreators(Array.isArray(data) ? data : [])
        } catch {
            swal('', 'Failed to load creators.', 'error')
        } finally {
            setLoading(false)
        }
    }

    const onDelete = (id) => {
        swal({
            title: 'Are you sure?',
            text: 'You want to delete this creator?',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (!willDelete) return
            setLoading(true)
            try {
                await axiosInstance.delete(`creators/${id}`)
                const updated = allCreators.filter(c => c.id !== id)
                setAllCreators(updated)
                swal('', 'Creator deleted successfully.', 'success')
            } catch {
                swal('', 'Failed to delete creator.', 'error')
            } finally {
                setLoading(false)
            }
        })
    }

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Creators" description="Manage content creators">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-12">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                {/* Toolbar */}
                                <div className='d-md-flex justify-content-between align-items-center mb-4'>
                                    <div className="d-flex align-items-center gap-3 mb-3 mb-md-0">
                                        <div className="ps-form--search-simple">
                                            <input className="form-control bg-white" type="text"
                                                value={search}
                                                onChange={e => setSearch(e.target.value)}
                                                placeholder="Search creators..." />
                                            <button type='button' style={{ right: '30px' }}>
                                                <i className="icon icon-magnifier"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className='d-flex gap-2'>
                                        <button type="button" className="button btn-green color-white"
                                            onClick={() => navigate(`${config.appUrl}settings/add-creator`)}>
                                            <i className='icon-plus me-2 fs-5'></i>Add Creator
                                        </button>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className='table-responsive'>
                                    <table className='jean-table table'>
                                        <tbody>
                                            {filtered.map((creator, index) => (
                                                <tr key={creator.id}>
                                                    <td width={60}>
                                                        {creator.photo
                                                            ? <img src={creator.photo} alt={creator.name}
                                                                style={{ width: 46, height: 46, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                                                            : <div className="rounded-circle d-flex align-items-center justify-content-center"
                                                                style={{ width: 46, height: 46, background: avatarColors[index % avatarColors.length], color: '#fff', fontWeight: 700, fontSize: 15, flexShrink: 0 }}>
                                                                {getInitials(creator.name)}
                                                              </div>
                                                        }
                                                    </td>

                                                    <td>
                                                        <div className='therapist-info'>
                                                            <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Name</p>
                                                            <p className='mb-0 fw-bold'>{creator.name}</p>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='therapist-info'>
                                                            <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Email</p>
                                                            <p className='mb-0'>{creator.email}</p>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='therapist-info'>
                                                            <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Phone</p>
                                                            <p className='mb-0'>{creator.phone}</p>
                                                        </div>
                                                    </td>

                                                    <td className='pe-3'>
                                                        <div className='d-flex gap-2 justify-content-end'>
                                                            <button className='btn btn-sm fw-semibold'
                                                                style={{ background: 'linear-gradient(135deg, #A44CD7, #0CACC2)', color: '#fff', borderRadius: 8, padding: '6px 14px', fontSize: 13 }}
                                                                onClick={() => navigate(`${config.appUrl}settings/edit-creator/${creator.id}`)}>
                                                                <i className='icon-pen me-1'></i>Edit
                                                            </button>
                                                            <button className='btn btn-sm fw-semibold'
                                                                style={{ background: '#EC2434', color: '#fff', borderRadius: 8, padding: '6px 14px', fontSize: 13 }}
                                                                onClick={() => onDelete(creator.id)}>
                                                                <i className='icon-trash2 me-1'></i>Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            {filtered.length === 0 && !loading && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <div className="alert alert-success ps-4">No Creators Found!</div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default CreatorIndex
